import MuiAccordion from '@mui/material/Accordion';
import { styled } from '@mui/material/styles';

export const Accordion = styled(MuiAccordion)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  boxShadow: 'none',
  margin: 0,
  overflow: 'visible',
  '&.Mui-expanded': { margin: 0 },
  '&:before': { display: 'none' },
}));
